import * as React from "react";
import { motion } from "framer-motion";

const variants = {
  open: {
    y: 0,
    opacity: 1,
    transition: {
      y: { stiffness: 1000, velocity: -100 }
    }
  },
  closed: {
    y: 50,
    opacity: 0,
    transition: {
      y: { stiffness: 1000 }
    }
  }
};

const colors = ["#ff00c3", "#ea00ff", "#b700ff", "#8800ff",  "#004cff"];
const names = ["Home", "About", "Education", "Works",  "Contact"];
const ic = ["fa fa-home", "fa fa-user", "fa fa-book", "fa fa-briefcase", "fa fa-phone"];
export const MenuItem = ({ i, props, toggle, dis }) => {
  const style = { border: `2px solid ${colors[i]}` , color: `black` };
  const style1 = { border: `2px solid ${colors[i]}` , width: `40px`, 
  height: `35px`,
  borderRadius: `50%`,
  flex: `40px 0`,
  
  marginRight: `20px`, color: `black`, fontSize:`30px`, textAlign: `center`, paddingTop: `5px`};
  
    
    return(
    <div>
    <motion.li
      variants={variants}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
      
      className="list"
      
    >
      
      <a className={ic[i]}  style={style1} href={"#"+names[i]} onClick={toggle}/>
      <a className="text-place" style={style} href={"#"+names[i]} onClick={toggle}>{names[i]} </a>
    </motion.li>
    </div>
  );
  
};

export default MenuItem;